module.exports = __webpack_public_path__ + "assets/images/qt2.789ebf1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return/qt2.png
// module id = 801
// module chunks = 1